import { Pill } from "@dashboard/components/Pill/Pill";
import { type AtticAssetDirectoryFragment } from "@dashboard/graphql";
import { Box } from "@saleor/macaw-ui-next";
import { useIntl } from "react-intl";

import { badgeMessages } from "../../messages";
import { isManagedByApp } from "../../utils";

/** Default / Managed by app / Writable or Read-only, in that order. */
export const AtticAssetDirectoryBadges = ({
  directory,
}: {
  directory: Pick<
    AtticAssetDirectoryFragment,
    "isDefault" | "isProtected" | "claimedBy" | "writable"
  >;
}) => {
  const intl = useIntl();

  return (
    <Box display="flex" gap={1} flexWrap="wrap" data-test-id="attic-asset-directory-badges">
      {directory.isDefault && (
        <Pill color="info" label={intl.formatMessage(badgeMessages.default)} />
      )}
      {isManagedByApp(directory) && (
        <Pill
          color="warning"
          label={
            directory.claimedBy
              ? intl.formatMessage(badgeMessages.managedBy, { name: directory.claimedBy })
              : intl.formatMessage(badgeMessages.managedByApp)
          }
        />
      )}
      <Pill
        color={directory.writable ? "success" : "generic"}
        label={intl.formatMessage(
          directory.writable ? badgeMessages.writable : badgeMessages.readOnly,
        )}
      />
    </Box>
  );
};
